import { render, staticRenderFns } from "./aliPayResult.vue?vue&type=template&id=7dbca6b0"
import script from "./aliPayResult.vue?vue&type=script&lang=js"
export * from "./aliPayResult.vue?vue&type=script&lang=js"
import style0 from "./aliPayResult.vue?vue&type=style&index=0&id=7dbca6b0&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports